import { useCallback, useMemo, useState } from "react";
import { applyDiscoverySortClick } from "../utils/adminGridClientSort";
import { sortConfigToDiscoveryApiParams } from "../utils/discoveryGridSort";
import usePersistStickyFilters from "./usePersistStickyFilters";
import {
  VENDOR_STICKY_SCREEN_KEYS,
  loadDiscoveryStickyFilterState,
  persistVendorStickyFilterState,
} from "../utils/vendorStickyFilterPersistence";

/**
 * Discovery grid sort + pagination with sessionStorage sticky restore.
 */
export function useDiscoveryGridSort(
  screenKey = VENDOR_STICKY_SCREEN_KEYS.DISCOVERY
) {
  const initial = useMemo(
    () => loadDiscoveryStickyFilterState(screenKey),
    [screenKey]
  );

  const [sortColumn, setSortColumn] = useState(initial.sortColumn);
  const [sortDirection, setSortDirection] = useState(initial.sortDirection);
  const [sortFetchNonce, setSortFetchNonce] = useState(0);
  const [currentPage, setCurrentPage] = useState(initial.currentPage);

  const discoverySortParams = useMemo(
    () =>
      sortConfigToDiscoveryApiParams({
        column: sortColumn,
        direction: sortDirection,
      }),
    [sortColumn, sortDirection]
  );

  const handleSort = useCallback(
    (column) => {
      applyDiscoverySortClick(sortColumn, sortDirection, column, {
        setSortColumn,
        setSortDirection,
        setSortFetchNonce,
        setCurrentPage,
      });
    },
    [sortColumn, sortDirection]
  );

  const persistedFilterState = useMemo(
    () => ({
      sortColumn,
      sortDirection,
      currentPage,
    }),
    [sortColumn, sortDirection, currentPage]
  );

  usePersistStickyFilters(
    screenKey,
    persistedFilterState,
    persistVendorStickyFilterState
  );

  return {
    sortColumn,
    sortDirection,
    sortFetchNonce,
    currentPage,
    setCurrentPage,
    discoverySortParams,
    handleSort,
  };
}
